export const AddonParamsMiddleware = (data: jsonResponse) => {
	if (data && data.addonParams && data.addonParams.cookieParams && data.addonParams.dataLayerParams) {
		for (var key in data.addonParams.cookieParams) {
			if (data.addonParams.cookieParams[key] && data.addonParams.cookieParams[key].length == 1) {
			}
		}

		var st = sessionStorage.getItem('st');
		if ((data.addonParams.dataLayerParams['st'] && data.addonParams.dataLayerParams['st'].length == 1) || st) {
			const startTime = data.addonParams.dataLayerParams['st']
				? parseInt(data.addonParams.dataLayerParams['st'][0])
				: parseInt(st);
			if (!isNaN(startTime)) {
				const thisDate = new Date();
				// var thisDateUtc = new Date(thisDate.getUTCFullYear(),
				// 							thisDate.getUTCMonth(),
				// 							thisDate.getUTCDate(),
				// 							thisDate.getUTCHours(),
				// 							thisDate.getUTCMinutes(),
				// 							thisDate.getUTCSeconds());

				let totalTime = thisDate.getTime() - startTime;
				if (totalTime < 0) {
					totalTime = 0;
				}
			}

			delete data.addonParams.dataLayerParams['st'];
		}

		for (var key in data.addonParams.dataLayerParams) {
			if (data.addonParams.dataLayerParams[key] && data.addonParams.dataLayerParams[key].length == 1) {
			}
		}
	}
};
